<fieldset class="app-fieldset" [class.collapsed]="collapsible && hideContent">
  <ng-container *ngIf="useClassicLegend">
    <legend *ngIf="isTemplateLegend()">
      <ng-container *ngTemplateOutlet="legend"></ng-container>
    </legend>
    <ng-container *ngIf="!isTemplateLegend()">
      <legend [innerHTML]="legend | safe: 'html'"></legend>
    </ng-container>
  </ng-container>

  <div class="fieldset-title" *ngIf="!useClassicLegend">
    <div class="title">
      <nz-icon [nzType]="nzIcon" nzTheme="outline" *ngIf="nzIcon" />
      <ng-container *ngIf="isTemplateLegend()">
        <ng-container *ngTemplateOutlet="legend"></ng-container>
      </ng-container>
      <ng-container *ngIf="!isTemplateLegend()">{{ legend }}</ng-container>
    </div>
    <div class="actions">
      @if (actions) {
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      }
      @if (collapsible) {
        <button
          nz-button
          nzType="default"
          nzSize="small"
          (click)="hideContent = !hideContent"
          nz-tooltip
          [nzTooltipTitle]="hideContent ? 'Show content' : 'Hide content'"
        >
          <nz-icon
            onKeyPress=""
            [nzType]="hideContent ? 'caret-down' : 'caret-up'"
            nzTheme="outline"
          />
        </button>
      }
    </div>
  </div>

  <div class="fieldset-content" [hidden]="hideContent">
    <ng-content></ng-content>
  </div>
</fieldset>
